import axios from "axios";

import { baseAxios } from "config";

const updateAvailabilityBlock = async ({ blocksAvailability, id, eventUrl }) => {
  const res = await baseAxios.put(`/users/id/${id}/availability-block`, {
    blocksAvailability,
    eventUrl,
  });
  return res.data;
};

export default updateAvailabilityBlock;
